"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("react-bootstrap/lib/Checkbox"));
var _bootstrapUtils = require("react-bootstrap/lib/utils/bootstrapUtils");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children", "showHelpText"];
var ToggleSwitch = function ToggleSwitch(_ref) {
  var children = _ref.children,
    showHelpText = _ref.showHelpText,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], rest, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('toggle-switch-inner', {
      'toggle-switch-help-text': showHelpText
    })
  }), children);
};
ToggleSwitch.propTypes = {
  children: _propTypes["default"].string,
  showHelpText: _propTypes["default"].bool
};
ToggleSwitch.defaultProps = {
  children: undefined,
  showHelpText: false
};
var _default = exports["default"] = (0, _bootstrapUtils.bsClass)('toggle-switch', ToggleSwitch);


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/ToggleSwitch.js
// module id = 776
// module chunks = 25